import React from 'react'
import PropTypes from 'prop-types'
import { Card, CircularProgress, Divider, Grid, Typography } from '@material-ui/core'
import { useAnaliseConstatacao } from './useAnaliseConstatacao'
import { DescricoesComAnalises } from './components/DescricoesComAnalises/DescricoesComAnalises'
import { useStyles } from './AnaliseConstatacao.styles'

export const AnaliseConstatacao = (props) => {
  const { idExameSolicitado, idExameRealizado, definitivo } = props
  const classes = useStyles()

  const { vestigios, processandoVestigios } = useAnaliseConstatacao(idExameSolicitado)

  return (
    <div className={classes.root}>
      {processandoVestigios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container spacing={2}>
          {vestigios?.map((vestigio) => (
            <Grid key={vestigio.id} item xs={12}>
              <Card className={classes.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography className={classes.title}>VESTÍGIO {vestigio.identificador}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider className={classes.divider} />
                  </Grid>
                  <Grid item container xs={12} className={classes.groupCard} spacing={2}>
                    <Grid item sm={6} xs={12}>
                      <Typography className={classes.subTitle}>DESCRIÇÃO PRELIMINAR</Typography>
                      <Typography variant="body2">{vestigio.descricao?.toUpperCase() || '-'}</Typography>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <Typography className={classes.subTitle}>LACRE</Typography>
                      <Typography variant="body2">{vestigio.lacre?.toUpperCase() || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '16px' }}>
                      <Typography className={classes.title}>DESCRIÇÕES TÉCNICAS</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={12}>
                      <DescricoesComAnalises idExameRealizado={idExameRealizado} idVestigio={vestigio.id} definitivo={definitivo} />
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  )
}

AnaliseConstatacao.propTypes = {
  idExameSolicitado: PropTypes.number,
  idExameRealizado: PropTypes.number.isRequired,
  definitivo: PropTypes.bool,
}
